import React, { useState, useEffect } from 'react';

const CountingEffect = ({ start = 0, end, duration = 2000, percentage }) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    const totalFrames = Math.round(duration / 16.66); // Approximation: 60 frames per second
    const increment = (end - start) / totalFrames;
    let currentCount = start;
    let frame = 0;

    const interval = setInterval(() => {
      frame++;
      currentCount += increment;
      setCount(Math.floor(currentCount));

      if (frame === totalFrames || currentCount >= end) {
        clearInterval(interval);
        setCount(end); // Ensure it ends at the correct value
      }
    }, 16.66); // Approximation: 60 FPS

    return () => clearInterval(interval); // Cleanup on unmount
  }, [start, end, duration]);

  return <>{count}{percentage && count !== 0 ? '%' : ''}</>;
};

export default CountingEffect;
